import API from 'services/api';

export const deleteiCalLite = ({
  iCalLinkId,
  deleteOccupancies = false,
}: {
  iCalLinkId: string;
  deleteOccupancies?: boolean;
}) =>
  API.delete(`/api/renter/accommodation/properties/iCal/${iCalLinkId}`, {
    params: {
      deleteOccupancies,
    },
  });
